'use client'

import { cn } from '@/src/utils/styles'

interface AnimatedEllipsisProps {
  className?: string
}

export function AnimatedEllipsis({ className }: AnimatedEllipsisProps) {
  return (
    <span className={cn('inline-flex', className)}>
      <span className='animate-[ellipsis_1.4s_infinite] opacity-0 [animation-delay:0s]'>
        .
      </span>
      <span className='animate-[ellipsis_1.4s_infinite] opacity-0 [animation-delay:0.2s]'>
        .
      </span>
      <span className='animate-[ellipsis_1.4s_infinite] opacity-0 [animation-delay:0.4s]'>
        .
      </span>
    </span>
  )
}
